// extracted by mini-css-extract-plugin
export default {"container":"chH1EyloK","error":"ch_SVtucp","placeholder":"cvDC13222","transparent":"c6qDfPyLX","default":"cuo9HYNX2"};